import { ApiV2 } from '../../commonv2/api/ApiV2';
import { locatePath } from '../../common/RelativeUrl';
import { Plan } from '../types/plan';

export const PlanApis = {
    base() {
        return new ApiV2(locatePath('/api/v2/new_plans'));
    },
    /**
     * Returns all plans that is currently active
     * @returns {Promise<Plan[]>}
     */
    async getAllPlans(campaignCode?: string): Promise<Plan[]> {
        return await this.base().get({ campaign_code: campaignCode });
    },
};
